import React from 'react';
import { NavLink } from 'react-router-dom';

const Header = () => (
    <header>
        <NavLink
            title="Return to home page."
            className="logo-header"
            exact to="/">pvqw
        </NavLink>
    </header>
);

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header.js